import PropTypes from "prop-types";
import {
  valuePropType,
  onChangePropType,
  placeholderPropType,
  classNamePropType,
  disabledPropType,
} from "../../common";

/**
 * PropTypes for Search component
 *
 * @property {string|number} [value] - Search input value
 * @property {function} [onChange] - Change handler callback - receives new search value
 * @property {string} [placeholder] - Placeholder text
 * @property {string} [className] - Additional CSS classes
 * @property {boolean} [disabled] - Disable search input
 * @property {function} [onSearch] - Search submission handler
 * @property {function} [onClear] - Clear button handler
 * @property {boolean} [showClearButton] - Show clear button when value exists
 */
export const searchPropTypes = {
  value: valuePropType,
  onChange: onChangePropType,
  placeholder: placeholderPropType,
  className: classNamePropType,
  disabled: disabledPropType,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  showClearButton: PropTypes.bool,
};
